/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component, Input } from '@angular/core';

import { MatButton } from '@angular/material/button';

import { Topic, Configuration } from '../shared';

@Component({
    selector: 'nv-post-launch-button',
    imports: [MatButton],
    templateUrl: './post-launch-button.component.html',
    styleUrl: './post-launch-button.component.scss'
})
export class PostLaunchButtonComponent {
    @Input() topics: Topic[] = [];
    @Input() runs: number = 0;

    constructor(private appConfig: Configuration) {}

    public getTopicPath(topic: Topic): string {
        return `${this.appConfig.vdkPlaytestConfig.publicLearnArticlesBaseUrl}/${topic.path}`;
    }

    public showButton(topic: Topic): boolean {
        return topic.playtestPortalPostRunButton !== undefined && this.runs > 0;
    }

    public getButtonTitle(topic: Topic): string {
        return topic.playtestPortalPostRunButton || '';
    }
}
